import * as React from 'react';
import {connect} from 'react-redux';
import FormSelect from 'cl-form/FormSelect';
import * as _ from 'lodash';
import {StoreState} from '../../../../App/initialStore';
import {FormSelectOption} from 'cl-form/utils/orderByUtils';

export default connect(
  (state: StoreState) => {
    return {
      options: _.map(
        state.accountPage.amazonAccounts,
        ({amazonSellerId, name}) => ({label: name, value: amazonSellerId} as FormSelectOption)
      ),
    };
  },
  {}
)(FormSelect);
